export const initialSelectedAree = {
  data: {
    customerOriginAreaID: "",
    originAreaName: "",
    associatedNumbers: [],
  },
  loading: false,
};
